import { DOCUMENT } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  Renderer2,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-data-protection-modal',
  templateUrl: './data-protection-modal.component.html',
  styleUrls: ['./data-protection-modal.component.css']
})
export class DataProtectionModalComponent implements OnChanges, OnDestroy {
  @Input() open = false;

  /*
   * Permite utilizar:
   * [(open)]="dataProtectionModalOpen"
   */
  @Output() openChange = new EventEmitter<boolean>();

  @Output() accept = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  private previousBodyOverflow = '';
  private scrollLocked = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.open) {
      return;
    }

    if (this.open) {
      this.lockBodyScroll();
    } else {
      this.unlockBodyScroll();
    }
  }

  ngOnDestroy(): void {
    this.unlockBodyScroll();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapePressed(event: KeyboardEvent): void {
    if (!this.open) {
      return;
    }

    event.preventDefault();
    this.requestClose();
  }

  requestClose(): void {
    this.open = false;

    this.openChange.emit(false);
    this.closed.emit();

    this.unlockBodyScroll();
  }

  requestAccept(): void {
    this.accept.emit();
    this.requestClose();
  }

  stopPropagation(event: MouseEvent): void {
    event.stopPropagation();
  }

  private lockBodyScroll(): void {
    if (this.scrollLocked || !this.document.body) {
      return;
    }

    this.previousBodyOverflow = this.document.body.style.overflow;

    this.renderer.setStyle(
      this.document.body,
      'overflow',
      'hidden'
    );

    this.scrollLocked = true;
  }

  private unlockBodyScroll(): void {
    if (!this.scrollLocked || !this.document.body) {
      return;
    }

    if (this.previousBodyOverflow) {
      this.renderer.setStyle(
        this.document.body,
        'overflow',
        this.previousBodyOverflow
      );
    } else {
      this.renderer.removeStyle(
        this.document.body,
        'overflow'
      );
    }

    this.scrollLocked = false;
  }
}